module.exports = __webpack_public_path__ + "static/img/college-head.ded03b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/college-head.png
// module id = 9k8Q
// module chunks = 1